import { createRoot } from 'react-dom/client'; // Thay thế ReactDOM bằng createRoot
import TagManager from 'react-gtm-module';
import { BrowserRouter as Router } from 'react-router-dom';
import * as Sentry from "@sentry/react";
// @ts-ignore
import markerSDK from '@marker.io/browser';
import App from './App';
import _ from './imports/lodash-imports';
import './styles/styles.scss';

// Google Tag Manager
const tagManagerArgs = {
  gtmId: 'GTM-WZH46SW',
};
TagManager.initialize(tagManagerArgs);

// Get domian
const domain = _.replace(
  _.replace(_.replace(window.location.origin, 'http://', ''), 'https://', ''),
  '/',
  ''
);

// Marker.io
if (domain === 'uat-quote.petsy.com.au') {
  // const widget = await markerSDK.loadWidget({
  const widget = markerSDK.loadWidget({
    destination: '61b7da3d58936e092b3b66b7', // <- Your unique destination ID
  });
}

// Sentry.init({
//   dsn: "https://5a1e1edbfeab6df06313ab560bbe07cb@o4509059574398976.ingest.de.sentry.io/4509059576102992",
//   integrations: [
//     Sentry.browserTracingIntegration(),
//     // Sentry.replayIntegration()
//   ],
//   // Tracing
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   // tracePropagationTargets: ["localhost", /^https:\/\/quote\.staging\.petsy\.com\.au/, /^https:\/\/quote\.petsy\.com\.au/],
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
//   beforeSend(event) {
//     // Log error nhưng không ngăn chặn việc gửi lên Sentry
//     console.error('Sentry captured error:', event);
//     return event;
//   }
// });

/** Lỗi “giả” từ WebView iOS: console/SDK gọi postMessage khi native chưa đăng ký handler — không nên log Sentry hay console.error (dễ gọi lại chính bridge hỏng). */
function isWebKitMessageHandlerNoise(event: ErrorEvent): boolean {
  const parts = [event.message, event.error?.message, String(event.error ?? '')].filter(Boolean);
  return parts.some((t) =>
    /webkit\.messageHandlers|messageHandlers\[.*\]\.postMessage/i.test(t),
  );
}

function isWebKitMessageHandlerNoiseReason(reason: unknown): boolean {
  const text =
    reason && typeof reason === 'object' && 'message' in reason && typeof (reason as Error).message === 'string'
      ? (reason as Error).message
      : String(reason ?? '');
  return /webkit\.messageHandlers|messageHandlers\[.*\]\.postMessage/i.test(text);
}

Sentry.init({
  // dsn: "https://caf5138f7a3106133bacc095e734e344@o4509058037776384.ingest.us.sentry.io/4509546472865797", // development
  dsn: "https://be745364e8f668b097025812b3489105@o4509058037776384.ingest.us.sentry.io/4509546471292933", // production
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  ignoreErrors: [
    /webkit\.messageHandlers/i,
    /messageHandlers\[.*\]\.postMessage/i,
  ],
});

// Global error handlers - "nuốt" lỗi để không crash app
window.addEventListener('error', (event) => {
  if (isWebKitMessageHandlerNoise(event)) {
    event.preventDefault();
    return false;
  }
  console.error('Global error caught and handled:', event.error);
  console.error('Error details:', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error
  });

  // Gửi lên Sentry để tracking
  Sentry ? Sentry.captureException(event.error, {
    tags: {
      errorType: 'global_error',
      handled: 'true'
    },
    extra: {
      message: event.message,
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno
    }
  }) : null;

  // Ngăn chặn lỗi lan ra ngoài và crash app
  event.preventDefault();
  return false;
});

window.addEventListener('unhandledrejection', (event) => {
  if (isWebKitMessageHandlerNoiseReason(event.reason)) {
    event.preventDefault();
    return false;
  }
  console.error('Unhandled promise rejection caught and handled:', event.reason);
  console.error('Promise rejection details:', {
    reason: event.reason,
    promise: event.promise
  });

  // Kiểm tra nếu là React error
  const isReactError = event.reason && event.reason.toString().includes('React');
  if (isReactError) {
    console.error('React error caught and handled:', event.reason);
  }

  // Gửi lên Sentry để tracking
  Sentry ? Sentry.captureException(event.reason, {
    tags: {
      errorType: 'unhandled_rejection',
      handled: 'true',
      isReactError: isReactError ? 'true' : 'false'
    },
    extra: {
      promise: event.promise,
      isReactError
    }
  }) : null;

  // Ngăn chặn lỗi lan ra ngoài và crash app
  event.preventDefault();
  return false;
});

// Sentry.init({
//   dsn: "https://5a1e1edbfeab6df06313ab560bbe07cb@o4509059574398976.ingest.de.sentry.io/4509059576102992",
//   // Adds request headers and IP for users, for more info visit:
//   // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
//   sendDefaultPii: true,
//   integrations: [
//   ],
// });
function ErrorButton() {
  return (
    <button
      onClick={() => {
        throw new Error('This is your first error!');
      }}
    >
      Break the world
    </button>
  );
}

const container = document.getElementById('root');
const root = createRoot(container!, {
  onRecoverableError: (error) => Sentry.captureException(error)
});
root.render(
  // @ts-ignore - Fix tạm thời cho lỗi TypeScript
  // <React.StrictMode>
  <Router>
    {/* <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
      <App />
    </Sentry.ErrorBoundary> */}
    <App />
  </Router>
  // </React.StrictMode>
);
